//mypreset.ts
import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const MyPreset = definePreset(Aura, {
    //Your customizations, see the following sections for examples
    // semantic: {
    //     primary: {
    //         50: '{emerald.50}',
    //         100: '{emerald.100}',
    //         200: '{emerald.200}',
    //         300: '{emerald.300}',
    //         400: '{emerald.400}',
    //         500: '{emerald.500}',
    //         600: '{emerald.600}',
    //         700: '{emerald.700}',
    //         800: '{emerald.800}',
    //         900: '{emerald.900}',
    //         950: '{emerald.950}'
    //     }
    // }
    // semantic: {
    //     primary: {
    //         50: '{gray.50}',
    //         100: '{gray.100}',
    //         200: '{gray.200}',
    //         300: '{gray.300}',
    //         400: '{gray.400}',
    //         500: '{gray.500}',
    //         600: '{gray.600}',
    //         700: '{gray.700}',
    //         800: '{gray.800}',
    //         900: '{gray.900}',
    //         950: '{gray.950}'
    //     }
    // }
//    semantic: {
//     primary: {
//         50: '#f9e5e5',
//         100: '#f2b8b8',
//         200: '#ea8a8a',
//         300: '#e05c5c',
//         400: '#d73434',
//         500: '#8b1a1a', // your main primary color
//         600: '#701414',
//         700: '#561010',
//         800: '#3c0b0b',
//         900: '#220606',
//         950: '#110303'
//     }
// }
   semantic: {
    primary: {
      50:  '#fff3e0',
      100: '#ffe0b2',
      200: '#ffcc80',
      300: '#ffb74d',
      400: '#ffa726',
      500: '#ffbb60', // 🔥 PRIMARY MAIN
      600: '#fb8c00',
      700: '#f57c00',
      800: '#ef6c00',
      900: '#e65100',
      950: '#bf360c'
    },

    secondary: {
      50:  '#fff1ea',
      100: '#ffd4bf',
      200: '#ffb699',
      300: '#ff986e',
      400: '#ff7f52',
      500: '#fe914e', // 🔥 SECONDARY MAIN
      600: '#f57c3a',
      700: '#ec6727',
      800: '#e25214',
      900: '#c64000',
      950: '#8f2e00'
    }
}
    // semantic: {
    //     primary: {
    //         50: '{red.50}',
    //         100: '{red.100}',
    //         200: '{red.200}',
    //         300: '{red.300}',
    //         400: '{red.400}',
    //         500: '{red.500}',
    //         600: '{red.600}',
    //         700: '{red.700}',
    //         800: '{red.800}',
    //         900: '{red.900}',
    //         950: '{red.950}'
    //     }
    // }
    // semantic: {
    //     primary: {
    //         50: '{yellow.50}',
    //         100: '{yellow.100}',
    //         200: '{yellow.200}',
    //         300: '{yellow.300}',
    //         400: '{yellow.400}',
    //         500: '{yellow.500}',
    //         600: '{yellow.600}',
    //         700: '{yellow.700}',
    //         800: '{yellow.800}',
    //         900: '{yellow.900}',
    //         950: '{yellow.950}'
    //     }
    // }
});

export default MyPreset;